export const PAYMENT_METHODS = [
  { value: "bank", label: "Bank / debit", account: "Bank" },
  { value: "card_processor", label: "Business card processor", account: "Merchant Processing Clearing" },
  { value: "cash", label: "Cash", account: "Cash" },
  { value: "owner_personal", label: "Owner received personally", account: "Owner's Draw" },
];
export const DEFAULT_PAYMENT_METHOD = "bank";
export const paymentMethodLabel = (v) => (PAYMENT_METHODS.find((m) => m.value === v) || PAYMENT_METHODS[0]).label;

export function PaymentMethodSelect({ value, onChange, testId, className = "", compact = false }) {
  return (
    <select value={value || DEFAULT_PAYMENT_METHOD} onChange={(e) => onChange(e.target.value)} data-testid={testId} aria-label="Payment method"
      className={`rounded-md border bg-white outline-none ${compact ? "px-2 py-1.5 text-xs" : "px-3 py-2 text-sm"} ${className}`} style={{ borderColor: "var(--bk-border)", color: "var(--bk-text)" }}>
      {PAYMENT_METHODS.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
    </select>
  );
}
